// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"201":"c55e4a2e","787":"ce0458c8"}[chunkId] + ".chunk.js";
};